<template>
  <div class="tla-form-group tla-form-group--margin-medium" v-if="showComponent">
    <label class="tla-form-group__label tla-form-group__label--required" v-html="testDriveBookingInterestLabel"></label>

    <div class="tla-form-group__touch-points">
      <touchpoint v-for="(item) in options"
        :key="item.touchpointValue"
        :collectionName="'testDriveBookingInterest'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isSelected="item.preSelect"
        :isRadioStyle="true"
        :validationScope="validationScope"
        @testDriveBookingInterest="submitTestDriveBookingInterest($event)">
        <div class="generic-touchpoint__text" slot="touchpoint" v-html="item.touchpointName"></div>
      </touchpoint>
    </div>
    <span class="tla-form-group__message" :class="getValidationClass('testDriveBookingInterest', 'message')">
      Please select an option.
    </span>
    <p v-if="testDriveBookingAdditionalInterestLabel" v-html="testDriveBookingAdditionalInterestLabel"></p>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Inject, Watch
} from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import { validationService } from '@/services/ValidationService';
import ExtraData from '@/models/ExtraData';
import Manufacturer from '@/models/vehicle/manufacturer';
import IRange from '@/models/vehicle/interfaces/range.d';
import Touchpoint from '../../models/Touchpoint';
import GenericTouchpointComponent from '../ui/GenericTouchPointComponent.vue';

@Component({
  components: {
  touchpoint: GenericTouchpointComponent
  }
  })
export default class TestDriveBookingInterestComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'In addition to your quote, would you like to book in a test drive?' })
  public testDriveBookingInterestLabel!: string;

  @Prop({ default: 'Four-fifths of car buyers insist on taking a test drive.' })
  public testDriveBookingAdditionalInterestLabel!: string;

  @Prop({ default: null })
  public validationScope!: string;

  public isReset: boolean = false;

  public get options(): Touchpoint[] {
    return [
      new Touchpoint('true', 'Yes'),
      new Touchpoint('false', 'No', this.isReset && !this.testDriveRequested)
    ];
  }

  public submitTestDriveBookingInterest(value: string) {
    const extraData = new ExtraData('testDriveInterest', value);
    this.$store.dispatch('enquiryModule/submitExtraData', extraData);
    this.$store.dispatch('enquiryModule/submitTestDriveChecked', value === 'true');
  }

  public get testDriveRequested(): boolean {
    return this.$store.getters['enquiryModule/testDriveRequested'];
  }

  public get currentManufacturer(): Manufacturer | null {
    return this.$store.getters['vehicleModule/currentManufacturer'];
  }

  public get currentRange(): IRange | null {
    return this.$store.getters['vehicleModule/currentRange'];
  }

  public get blockedRangeIds(): number[] {
    return this.$store.getters['testDriveAvailabilityModule/blockedRangeIds'];
  }

  public get allowedTestDriveManufacturerIds(): number[] {
    return this.$store.getters['testDriveAvailabilityModule/allowedManufacturerIds'];
  }

  public get showComponent(): boolean {
    return this.currentManufacturer !== null
      && this.allowedTestDriveManufacturerIds.includes(this.currentManufacturer.manufacturerId)
      && this.currentRange !== null
      && !this.blockedRangeIds.includes(this.currentRange.rangeId);
  }

  @Watch('testDriveRequested')
  public testDriveRequestChanged(val: boolean, oldVal: boolean) {
    if (!val && oldVal) {
      this.isReset = true;
    }
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService
      .getValidationClass(this.$validator, fieldName, fieldType, false, false, this.validationScope);
  }
}
</script>
